/* =========================================================
   147 Product Purchase Row
   Dawn 15.5

   Moves Dawn's EXISTING quantity selector alongside
   Dawn's EXISTING Add to cart button.

   No quantity inputs or product forms are duplicated.
   ========================================================= */

(() => {
  if (window.__147ProductPurchaseRowInitialized) {
    return;
  }

  window.__147ProductPurchaseRowInitialized = true;

  const ROW_CLASS = 'a147-product-purchase-row';

  const findQuantityBlock = (productInfo) => {
    /*
     * Try Dawn quantity wrapper IDs first.
     */
    let quantityBlock = productInfo.querySelector(
      '[id^="Quantity-Form-"]'
    );

    if (quantityBlock) {
      return quantityBlock;
    }

    /*
     * Fallback:
     * Find Dawn's actual quantity-input component,
     * then use its closest product quantity wrapper.
     */
    const quantityInput = productInfo.querySelector(
      'quantity-input.quantity'
    );

    if (!quantityInput) {
      return null;
    }

    quantityBlock =
      quantityInput.closest('.product-form__quantity') ||
      quantityInput.parentElement;

    return quantityBlock;
  };

  const arrangeProductInfo = (productInfo) => {
    if (!productInfo) {
      return;
    }

    const quantityBlock =
      findQuantityBlock(productInfo);

    const productForm =
      productInfo.querySelector('product-form');

    if (!quantityBlock || !productForm) {
      return;
    }

    const buttons =
      productForm.querySelector(
        '.product-form__buttons'
      );

    const submitButton =
      buttons?.querySelector(
        '.product-form__submit'
      );

    if (!buttons || !submitButton) {
      return;
    }

    let purchaseRow =
      buttons.querySelector(
        `.${ROW_CLASS}`
      );

    if (!purchaseRow) {
      purchaseRow =
        document.createElement('div');

      purchaseRow.className =
        ROW_CLASS;

      buttons.insertBefore(
        purchaseRow,
        submitButton
      );
    }

    /*
     * Move the EXISTING quantity block.
     * Do not clone it.
     */
    if (
      quantityBlock.parentElement !==
      purchaseRow
    ) {
      purchaseRow.appendChild(
        quantityBlock
      );
    }

    /*
     * Move Dawn's EXISTING Add to cart button
     * beside the quantity selector.
     */
    if (
      submitButton.parentElement !==
      purchaseRow
    ) {
      purchaseRow.appendChild(
        submitButton
      );
    }
  };

  const arrangeAll = (
    scope = document
  ) => {
    if (
      scope instanceof Element &&
      scope.matches('product-info')
    ) {
      arrangeProductInfo(scope);
    }

    scope
      .querySelectorAll?.('product-info')
      .forEach((productInfo) => {
        arrangeProductInfo(productInfo);
      });
  };

  let scheduled = false;

  const scheduleArrange = () => {
    if (scheduled) {
      return;
    }

    scheduled = true;

    window.requestAnimationFrame(() => {
      scheduled = false;
      arrangeAll(document);
    });
  };

  const init = () => {
    arrangeAll(document);

    /*
     * Dawn can replace product markup after
     * variant changes, so watch for updates.
     */
    const observer =
      new MutationObserver(() => {
        scheduleArrange();
      });

    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true,
      }
    );
  };

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      init,
      {
        once: true,
      }
    );
  } else {
    init();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      arrangeAll(event.target);
    }
  );
})();